/* Phone and tablet share this step: one full-screen screen, the same as the
   search screen. AppModal renders no centred card around it. */
export const isHourlyFullScreen = () => true;
